import React, { useEffect } from "react";
import { useField } from "formik";
import { Alert } from "components/bootstrap";
import { Select, Spinner } from "components/common";
import RepositoryOption from "./RepositoryOption";
import useRepositories from "./hooks/useRepositories";
const RepositorySelect = ({ fieldName, handleDelete, disabled = false }) => {
  var _a;
  const [{ name, onChange, onBlur }, { value, touched }, { setValue }] = useField(fieldName);
  const { repositories } = useRepositories();
  const buildOptions = () => repositories.data.map((repo) => ({
    value: repo.repository.name,
    label: repo.repository.name,
    ready: repo.ready,
    type: repo.repository.type,
    description: repo.details
  }));
  const optionRenderer = (option, isSelected) => /* @__PURE__ */ React.createElement(RepositoryOption, { repository: option, onDelete: handleDelete, isSelected });
  useEffect(() => {
    var _a2;
    if (!touched && value === null && ((_a2 = repositories.data) == null ? void 0 : _a2.length) > 0) {
      setValue(repositories.data[0].repository.name);
    }
  }, [touched, setValue, value, repositories.data]);
  if (repositories.isLoading) return /* @__PURE__ */ React.createElement(Spinner, { text: "Fetching warm storage repositories..." });
  if (((_a = repositories.data) == null ? void 0 : _a.length) === 0)
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "No warm storage repositories existing, please create one.");
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      disabled,
      placeholder: "Select an existing warm storage repository",
      options: buildOptions(),
      optionRenderer,
      autoFocus: true,
      required: true,
      onBlur,
      onChange: (selected) => onChange({ target: { value: selected, name } }),
      value
    }
  );
};
export default RepositorySelect;
